import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedText } from '@mews/framework';
import { UnicodeEntity } from '@mews/enums';
import { PaymentCard, ApplicationState } from '@mews-commander/types';
import { getPaymentCard } from '@mews-commander/legacy-entities/src/ducks/paymentCards';

interface StateProps {
    paymentCard: PaymentCard | undefined;
}
interface OwnProps {
    paymentCardId: string;
}
type Props = StateProps & OwnProps;

const PaymentCardInfo = ({ paymentCard }: Props) => {
    if (!paymentCard) {
        return null;
    }
    const { lastDigits, type, format } = paymentCard;

    return (
        <>
            {lastDigits}
            {UnicodeEntity.LeftParenthesis}
            {type}
            {UnicodeEntity.ForwardSlash}
            <LocalizedText textKey={format as unknown as Mews.TextKey} />
            {UnicodeEntity.RightParenthesis}
        </>
    );
};
export default connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        paymentCard: (state: ApplicationState, { paymentCardId }: OwnProps) =>
            getPaymentCard(state, { id: paymentCardId }),
    })
)(PaymentCardInfo);
